// extracted by mini-css-extract-plugin
export default {"imageContainer":"xaa-z","summaryPar":"yaa-z","ratingCategories":"zaa-z","reviewerInfo":"Aaa-z","reviewTypes":"Baa-z","expanded":"Caa-z"};